<script>

import { API_PAY_SUMMARY } from '../../common/api'
import MyPagination from '../../components/MyPagination'
import DatePicker from '../../components/DatePicker'
import VillageSelect from '../../components/VillageSelect'
import BaseList from '../BaseList'
import {statusEnum, statusOptions, methodEnum, methodOptions} from '../../assets/js/common'

export default {
  name: 'Income',
  extends: BaseList,
  data () {
    return {
      searchForm: {
        village_id: '',
        method: '',
        status: '',
        start_date: '',
        end_date: ''
      },
      userId: this.$store.state.home.user_obj.id,
      summary: {},
      sum_balance: '',
      methodOptions: methodOptions,
      statusOptions: statusOptions
    }
  },
  created () {
    this.getVillageList();
    this.setTableHeight()
    if (this.userId === 3) {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      this.searchForm.start_date = `${year}-${month}-01`
      const day = now.getDate().toString().padStart(2, '0')
      this.searchForm.end_date = `${year}-${month}-${day}`
      this.currentPage = 1
      this.getDataList()
    }
  },
  methods: {
    getDataList () {
      this.loading = true;
      let params = {
        page_no: this.currentPage,
        page_num: this.pageSize,
        village_id: this.searchForm.village_id,
        method: this.searchForm.method,
        status: this.searchForm.status,
        start_date: this.searchForm.start_date,
        end_date: this.searchForm.end_date
      };
      this.$http.GET(API_PAY_SUMMARY, params,
      res => {
        this.loading = false;
        this.tableData = res.result.list;
        this.totalCount = res.result.total;
        this.summary = res.result.summary;
        this.sum_balance = res.result.sum_balance;
      }, err => {
        this.loading = false;
        this.$message.error(err.msg);
      })
    },
    setTableHeight () {
      this.tableHeight = window.innerHeight - 251
    },
    datePickerChange (obj) {
      this.searchForm.start_date = obj.start_date;
      this.searchForm.end_date = obj.end_date;
      this.currentPage = 1;
      this.getDataList()
    },
    selectVillage (data) {
      this.searchForm.village_id = data;
      this.currentPage = 1;
      this.getDataList()
    },
  },
  components: {
    MyPagination,
    DatePicker,
    VillageSelect
  }
}
</script>

<template>
  <div>
    <div class="search_section">
      <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
        <el-form-item>
          <VillageSelect @selectVillageId='selectVillage' defaultVillageId=0></VillageSelect>
        </el-form-item>
        <el-form-item>
        <el-form-item class="search_item">
          <el-select v-model="searchForm.method" clearable placeholder="缴费方式" @change="searchData">
          <el-option
            v-for="item in methodOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
         <el-form-item class="search_item">
          <el-select v-model="searchForm.status" clearable placeholder="操作内容" @change="searchData">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
           <el-form-item v-if="userId !== 3" class="search_item search_date_picker">
             <date-picker @datePickerChange="datePickerChange"></date-picker>
           </el-form-item>
        </el-form-item>
          <el-button type="primary" @click="searchData">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="summary_div">
      <div class="summary_item" style="background-color: #FFBE2B;">
        <div>所有收入</div>
        <div>￥{{summary.all_income}}</div>
      </div>
      <div class="summary_item" style="background-color: #E03647;">
        <div>应收水费</div>
        <div>￥{{summary.water_income}}</div>
      </div>
      <div class="summary_item" style="background-color: #9E75BE;">
        <div>水资源税</div>
        <div>￥{{summary.tax_income}}</div>
      </div>
      <div class="summary_item" style="background-color: #21A547;">
        <div>水厂缴费</div>
        <div>￥{{summary.company_pay}}</div>
      </div>
      <div class="summary_item" style="background-color: #00779F;">
        <div>余额缴费</div>
        <div>￥{{summary.balance_pay}}</div>
      </div>
      <div class="summary_item" style="background-color: #136C01;">
        <div>水厂充值</div>
        <div>￥{{summary.company_recharge}}</div>
      </div>
      <div class="summary_item" style="background-color: #00BEFF;">
        <div>微信充值</div>
        <div>￥{{summary.we_chat_recharge}}</div>
      </div>
<!--      <div class="summary_item" style="background-color: #9E75BE;">-->
<!--        <div>用户余额</div>-->
<!--        <div>￥{{sum_balance}}</div>-->
<!--      </div>-->
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{background: '#eef1f6', color: '#606266'}"
      highlight-current-row
      size="small"
      :height="tableHeight"
      border
      style="padding: 5px;">
      <el-table-column label="所有收入" prop="all_income"></el-table-column>
      <el-table-column label="应收水费" prop="water_income"></el-table-column>
      <el-table-column label="水资源税" prop="tax_income"></el-table-column>
      <el-table-column label="水厂缴费" prop="company_pay"></el-table-column>
      <el-table-column label="微信缴费" prop="we_chat_pay"></el-table-column>
      <el-table-column label="余额缴费" prop="balance_pay"></el-table-column>
      <el-table-column label="水厂充值" prop="company_recharge"></el-table-column>
      <el-table-column label="微信充值" prop="we_chat_recharge"></el-table-column>
      <el-table-column label="日期" prop="effect_date"></el-table-column>
    </el-table>

    <!-- 分页 -->
    <MyPagination :totalCount="totalCount" :currentPage="currentPage" @handleSizeChange="handleSizeChange"
                  @handleCurrentChange="handleCurrentChange"></MyPagination>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

.search_date_picker {
  padding-top: 1px;
  .date_picker {
    width: 250px;
  }
}

.summary_div {
  width: 100%;
  height: 100px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  .summary_item {
    height: 80px;
    margin: 0px 5px 0 5px;
    width: 14%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/page/income/Income.vue